<div class="scaffold-editable-text">
  <input #inlineEditControl *ngIf="editing && !checkDisable()" [required]="required" (blur)="onBlur($event)" (keyup.enter)="onBlur($event)" [(ngModel)]="value" [type]="type" [placeholder]="item.label" (click)="inEdit($event)" />
  <div *ngIf="!editing">
    <div [title]="'click_to_edit'| translation" (click)="edit(value)" (focus)="edit($event,value);" tabindex="0" class="inline-edit" [innerHTML]="displayText(value)|safeHtml"></div>
    <span class="edit-icon"><i class="fas fa-pencil-alt"> </i></span>
  </div>
  <div *ngIf="checkDisable()" [innerHTML]="displayText(value)|safeHtml">
  </div>
</div>
